export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
            关于今日大瓜
          </h2>
          <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            <p>
              今日大瓜网创立于 2024 年，是国内领先的娱乐吃瓜资讯聚合平台。我们致力于为吃瓜爱好者提供最新、最全、最靠谱的娱乐大瓜内容。
            </p>
            <p>
              平台坚持「多源核验、极速更新、专题整理」三大原则，每条吃瓜资讯均标注信息来源和可信度等级，让吃瓜群众告别真假难辨的烦恼。目前日均更新 30-50 条精选吃瓜资讯，覆盖影视、综艺、明星动态、恋情曝光、争议事件等九大专题板块。
            </p>
            <p>
              我们相信，吃瓜不仅是消遣，更是一种了解娱乐文化的方式。今日大瓜将持续优化内容质量，为每一位吃瓜爱好者提供值得信赖的一站式吃瓜体验。
            </p>
          </div>
          <div className="flex flex-wrap justify-center gap-6 mt-8">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-primary-500" style={{ fontFamily: 'var(--font-heading)' }}>30w+</p>
              <p className="text-xs text-foreground-500 mt-1">日均活跃用户</p>
            </div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-accent-500" style={{ fontFamily: 'var(--font-heading)' }}>2w+</p>
              <p className="text-xs text-foreground-500 mt-1">累计吃瓜资讯</p>
            </div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-primary-500" style={{ fontFamily: 'var(--font-heading)' }}>99.7%</p>
              <p className="text-xs text-foreground-500 mt-1">信息核验率</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}